import { useCallback } from 'react';
import { expValEquals, UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { useBoard } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/board/index.tsx';
import { createRouterSelector, useRouterActions } from '@atlassian/react-resource-router';
import { getFeatureMap } from '../../common/constants.tsx';
import type { ToggleableFeatureKey } from '../../common/types.tsx';

const useRouteName = createRouterSelector((s) => s.route.name);

export const useRedirect = (projectUrl: string) => {
	const routeName = useRouteName();
	const { replace } = useRouterActions();
	const { data: board } = useBoard();

	const redirect = useCallback(
		(featureId: ToggleableFeatureKey, isEnabling: boolean) => {
			const [expConfig] = UNSAFE_noExposureExp('jsw_simplify_navigation_m2');

			const featureMap = getFeatureMap({
				isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
				isListViewEnabled: expValEquals('jsw_list_view', 'cohort', 'variation'),
			});
			if (board && board.id) {
				if (!isEnabling && featureMap[featureId].redirectOn?.includes(routeName)) {
					replace(`${projectUrl}/boards/${board.id}`);
				}
			}
		},
		[board, projectUrl, replace, routeName],
	);

	return redirect;
};
